module.exports = __webpack_public_path__ + "assets/img/btn-view-all-hover-358225d5.png";